/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StarClubCollectionTile',[
		'lodash',
		'pixi',
		'absolute/stringmanager',
		'absolute/screenmetrics',
		'absolute/coords',
		'absolute/spriteutils',
		'absolute/audiomanager',
		'absolute/particleemitter',
		'Managers/StatManager',
		'MenuUI/MenuTile',
		'MenuUI/Label'
	],
	function (_, PIXI, _s, ScreenMetrics, Coords, SpriteUtils, AudioManager, ParticleEmitter, StatManager,
	          MenuTile, Label) {
		"use strict";


		var StarClubCollectionTile = function (config, collection, menu) {
			var defaultConfig = {};
			this.initStarClubCollectionTile(_.extend(defaultConfig, config), collection, menu);
		};

		StarClubCollectionTile.constructor = StarClubCollectionTile;
		StarClubCollectionTile.prototype = Object.create(MenuTile.prototype);

		StarClubCollectionTile.prototype.initStarClubCollectionTile = function (config, collection, menu) {
			MenuTile.call(this, config);
			this.collection = collection;
			this.menu = menu;

			// overlay

			this.progressOverlay = PIXI.Sprite.fromFrame("star_club/sc_tile_info_rect.png");
			this.progressOverlay.y = this.height - this.progressOverlay.height;

			//this.addChild(overlay);

			var packProgressLabelConfig = {
				icon: null,
				text: '',
				maxWidth: Coords.x(260),
				letterStyle: {
					font: ScreenMetrics.getResScale() * 26 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#ffffff',
					tint: 0xffffff,
					align: 'left'
				}
			};

			packProgressLabelConfig.text = this.collection.NumPacksCompleted + "/" + this.collection.NumPacks + " " + _s("starClub.packsCompleted");
			this.packProgressLabel = new Label(packProgressLabelConfig);
			this.packProgressLabel.pivot.set(this.progressOverlay.width / 2, this.packProgressLabel.height / 2);
			this.packProgressLabel.x = (this.progressOverlay.width) / 2 + Coords.x(30);
			this.packProgressLabel.y = this.progressOverlay.height - Coords.y(10);
			this.progressOverlay.addChild(this.packProgressLabel);

			var starProgressLabelConfig = {
				icon: "star_club/sc_tile_info_star.png",
				text: '',
				letterStyle: {
					font: ScreenMetrics.getResScale() * 22 + 'px Arial',
					fill: '#FDEF39',
					fontFamily: 'segoe',
					tint: 0xFDEF39,
					align: 'left'
				}
			};

			starProgressLabelConfig.text = this.collection.NumStarsEarned + "/" + this.collection.NumStars;
			this.starProgressLabel = new Label(starProgressLabelConfig);
			this.starProgressLabel.x = this.progressOverlay.width - this.starProgressLabel.width - Coords.x(10);
			this.starProgressLabel.y = Coords.y(10);
			this.progressOverlay.addChild(this.starProgressLabel);

			if (collection.PriceOfUnlocking > 0 && !collection.Unlocked) {
				this.lockedOverlay = new PIXI.Graphics();//PIXI.Sprite.fromFrame("star_club/rect_SC_locked.png");
				this.lockedOverlay.beginFill(0, 0.5);
				this.lockedOverlay.drawRect(0, 0, this.width - Coords.x(20), this.height - Coords.y(20));
				this.lockedOverlay.position.set(0, Coords.y(20));

				this.lockGroup = new PIXI.DisplayObjectContainer();

				var starsLabel = new Label(
					{
						icon: "star_club/sc_tile_info_star.png",
						text: collection.PriceOfUnlocking.toString(),
						letterStyle: {
							font: ScreenMetrics.getResScale() * 30 + 'px Arial',
							fontFamily: 'segoe',
							fill: '#ffffff',
							align: 'center'
						}
					});

				starsLabel.x = (this.lockedOverlay.width - starsLabel.width) / 2;

				this.lockGroup.addChild(starsLabel);


				var toUnlockLabel = new Label(
					{
						icon: null,
						text: _s("starClub.toUnlock"),
						maxWidth: Coords.x(280),
						letterStyle: {
							font: ScreenMetrics.getResScale() * 30 + 'px Arial',
							fontFamily: 'segoe',
							fill: '#ffffff',
							align: 'center'
						}
					});
				toUnlockLabel.x = (this.lockedOverlay.width - toUnlockLabel.width) / 2;
				toUnlockLabel.y = starsLabel.y + starsLabel.height + Coords.y(5);

				this.lockGroup.addChild(toUnlockLabel);

				this.lockIcon = PIXI.Sprite.fromFrame("star_club/SC_challenge_lock.png");
				this.lockIcon.x = (this.lockedOverlay.width - this.lockIcon.width) / 2;
				this.lockIcon.y = toUnlockLabel.y + toUnlockLabel.height + Coords.y(15);

				this.lockGroup.addChild(this.lockIcon);

				this.lockGroup.x = 0;
				this.lockGroup.y = (this.lockedOverlay.height - this.lockGroup.height) / 2;
				this.lockedOverlay.addChild(this.lockGroup);

				this.addChild(this.lockedOverlay);
			} else {
				this.addChild(this.progressOverlay);
			}
			this.initTooltip();
			this.updateCrown(false);
			window.addEventListener('mousedown', function(event) {
				if (StarClubCollectionTile.lastInfoBox) StarClubCollectionTile.lastInfoBox.visible = false;
			});
		};

		StarClubCollectionTile.prototype.updatePackProgress = function () {
			this.packProgressLabel.setText(this.collection.NumPacksCompleted + "/" + this.collection.NumPacks + " " + _s("starClub.packsCompleted"));
		};

		StarClubCollectionTile.prototype.updateStarProgress = function () {
			this.starProgressLabel.setText(this.collection.NumStarsEarned + "/" + this.collection.NumStars);
			this.starProgressLabel.x = this.progressOverlay.width - this.starProgressLabel.width - Coords.x(10);
		};

		StarClubCollectionTile.prototype.onShow = function () {
			this.updatePackProgress();
			this.updateStarProgress();
			this.updateCrown(true);

			if (this.collection.Unlocked && !this.animateUnlockComplete && StatManager.GetValue("SCGlobalStarsEarned") >= this.collection.PriceOfUnlocking) {
				this.removeChild(this.lockedOverlay);
				this.addChild(this.progressOverlay);
			}

			this.interactive = true;
		};

		StarClubCollectionTile.prototype.handleClick = function () {
			if (this.collection.Unlocked) {
				MenuTile.prototype.handleClick.call(this);
			} else {
				if (StatManager.GetValue("SCGlobalStarsEarned") >= this.collection.PriceOfUnlocking) {
					this.animateUnlock();
				} else {
					if (StarClubCollectionTile.lastInfoBox) StarClubCollectionTile.lastInfoBox.visible = false;
					StarClubCollectionTile.lastInfoBox = this.infoBoxContainer;
					this.infoBoxContainer.openBox();
					this.interactive = true;
				}
			}
		};

		StarClubCollectionTile.prototype.animateUnlock = function () {

			this.collection.Unlocked = true;
			this.unlockAnimation = SpriteUtils.loadMovieClip("unlock_animation/unlocking-animation_", 30, 1);
			this.unlockAnimation.animationSpeed = 30 / 60;
			this.unlockAnimation.loop = false;
			this.unlockAnimation.scale.x = this.unlockAnimation.scale.y = 1.45;

			this.unlockAnimation.x = Coords.y(3) + (this.lockedOverlay.width - this.unlockAnimation.width) / 2;
			this.unlockAnimation.y = Coords.y(65) + (this.lockedOverlay.width - this.unlockAnimation.height) / 2;

			this.lockGroup.removeChild(this.lockIcon);
			this.lockedOverlay.addChild(this.unlockAnimation);

			this.unlockAnimation.onComplete = function () {
				this.removeChild(this.lockedOverlay);
				this.addChild(this.progressOverlay);
				this.interactive = true;
				this.animateUnlockComplete = true;
			}.bind(this);

			AudioManager.playSound('sc_starFlying_isolated');
			this.menu.game.menuBar.starCountDisplay.triggerStarAnimation(this, true, function () {
				AudioManager.playSound('sc_starUnlock');
				this.unlockAnimation.gotoAndPlay(0);
				this.menu.game.menuBar.starCountDisplay.triggerStarAnimation(this, false);
			}.bind(this));


		};

		StarClubCollectionTile.prototype.updateCrown = function (animate) {
			if (this.collection.NumStarsEarned === this.collection.NumStars && !this.crown) {
				// animate the crown
				var self = this;
				this.crown = PIXI.Sprite.fromFrame('star_club/crown.png');
				this.crown.anchor.x = this.crown.anchor.y = 0.5;
				this.crown.x = this.width / 2;
				this.crown.y = this.height / 2;
				this.addChild(this.crown);

				if (animate) {

					AudioManager.playSound('CrownAppearance');

					var textures1 = [PIXI.Texture.fromFrame('particle_glow_yellow.png')],
						textures2 = [PIXI.Texture.fromFrame('Star_orng_dot.png'), PIXI.Texture.fromFrame('Star_yellow_dot.png'), PIXI.Texture.fromFrame('Star_yel.png')],
						particleOptions1 = {
							rate: {numpan: {a: 8, b: 12, center: true}, timepan: {a: 0.01, b: 0.002, center: null}},
							mass: 1,
							rotation: {a: [0, 1], b: [0, 3], style: 'add'},
							velocity: [0.2, 0.5, 1],
							alpha: {a: 1, b: 0},
							scale: {a: [0.5, 1], b: 0, center: null},
							gravity: 0,
							life: {a: 1, b: 1.5, center: null},
							radius: 1,
							crossZone: null,
							randomDrift: null
						},
						particleOptions2 = {
							rate: {numpan: {a: 2, b: 4, center: true}, timepan: {a: 0.01, b: 0.002, center: null}},
							mass: 1,
							rotation: {a: [0, 1], b: [0, 3], style: 'add'},
							velocity: [0.5, 1],
							alpha: {a: 0.5, b: 0},
							scale: {a: [0.3, 0.3, 0.5], b: 0, center: null},
							gravity: 0,
							life: {a: 1, b: 2, center: null},
							radius: 1,
							crossZone: null,
							randomDrift: null
						},
						emitter1 = new ParticleEmitter(this.menu.ui, textures1, particleOptions1),
						emitter2 = new ParticleEmitter(this.menu.ui, textures2, particleOptions2),
						self = this;

					this.addChild(emitter1);
					this.addChild(emitter2);

					emitter1.x = emitter2.x = this.crown.x;
					emitter1.y = emitter2.y = this.crown.y;

					this.crown.alpha = 0;

					emitter1.start();

					var crownAlpha = new TWEEN.Tween({alpha: 0})
						.easing(TWEEN.Easing.Exponential.In)
						.to({alpha: 1}, 1200)
						.onStart(function () {
							window.setTimeout(function () {
								emitter1.stop();
							}, 600)
						})
						.onUpdate(function () {
							self.crown.alpha = this.alpha;
						})
						.start();

					var crownBounce = new TWEEN.Tween({scale: 1})
						.delay(500)
						.easing(TWEEN.Easing.Elastic.Out)
						.to({scale: [1.5, 1]}, 1500)
						.onStart(function () {
							window.setTimeout(function () {
								emitter2.start();
							}, 700);
						})
						.onUpdate(function () {
							self.crown.scale.x = self.crown.scale.y = this.scale;
						})
						.onComplete(function () {
							emitter2.stop();
							window.setTimeout(function () {
								self.removeChild(emitter1);
								self.removeChild(emitter2);
								emitter1.destroy();
								emitter2.destroy();
							}, 2000);
						})
						.start();
				}
			}
		};

		StarClubCollectionTile.prototype.initTooltip = function () {
			this.infoBoxContainer = new PIXI.DisplayObjectContainer();
			var infoBox = new PIXI.Graphics(),
				letterStyle = {
					font: ScreenMetrics.getResScale() * 19 + 'px Arial',
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left',
					wordWrap: true,
					wordWrapWidth: this.width
				},
				infoBoxText = new PIXI.Text(_s("starClub.tooltip"), letterStyle);
			infoBox.beginFill(0x000000);
			infoBox.lineStyle(3, 0xffffff, 1);
			infoBox.drawRect(0, 0, this.width + Coords.x(10), infoBoxText.height + Coords.y(10));
			infoBox.endFill();
			infoBoxText.x = Coords.x(7);
			infoBoxText.y = Coords.y(10);
			this.infoBoxContainer.addChild(infoBox);
			this.infoBoxContainer.addChild(infoBoxText);
			this.infoBoxContainer.visible = false;
			this.infoBoxContainer.x = this.width / 2 - this.infoBoxContainer.width / 2;

			this.onOpenBox(this.infoBoxContainer, infoBoxText);
		};

		StarClubCollectionTile.prototype.onOpenBox = function (infoBoxContainer, infoBoxText) {
			this.infoBoxContainer.openBox = function () {
				var earnedStars = StatManager.GetValue("SCGlobalStarsEarned");
				infoBoxContainer.visible = true;
				infoBoxContainer.x = this.width / 2 - infoBoxContainer.width / 2;
				infoBoxContainer.y = -Coords.y(75);
				infoBoxText.text = infoBoxText.text.replace('$$$', this.collection.PriceOfUnlocking - earnedStars);
				infoBoxText.updateText();
				if (infoBoxContainer.visible) {
					this.addChild(infoBoxContainer);
					new TWEEN.Tween({alpha: 0})
						.easing(TWEEN.Easing.Cubic.InOut)
						.to({alpha: 1}, 350)
						.onUpdate(function (p) {
							infoBoxContainer.alpha = this.alpha;
						})
						.start();
					if (this.hideTimeout) clearTimeout(this.hideTimeout);
					this.hideTimeout = window.setTimeout(function () {
						var hideTween = new TWEEN.Tween({alpha: 1})
							.easing(TWEEN.Easing.Cubic.InOut)
							.to({alpha: 0}, 350);
						hideTween.start();
						hideTween.onUpdate(function () {
							infoBoxContainer.alpha = this.alpha;
						});
						hideTween.onComplete(function () {
							infoBoxContainer.visible = false;
						});
					}, 3000);
				}
			}.bind(this);
		};


		return StarClubCollectionTile;
	})
;
